import { render } from "./quickstars.vue?vue&type=template&id=7c329f67&scoped=true"
import script from "./quickstars.vue?vue&type=script&lang=js"
export * from "./quickstars.vue?vue&type=script&lang=js"

import "./quickstars.vue?vue&type=style&index=0&id=7c329f67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c329f67"]])

export default __exports__